import { Link } from 'react-router-dom';
import Reveal from '@/components/base/Reveal';
import { locations } from '@/mocks/locations';

export default function Locations() {
  return (
    <section id="locations" className="scroll-mt-[76px] bg-background-100 border-t-[2.5px] border-foreground-950 wrap py-20 md:py-28">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-6 items-end mb-12 md:mb-16">
        <div className="md:col-span-8" data-m-group>
          <div data-m="fade"><span className="sticker bg-accent-500 text-background-50 tilt-r">locations</span></div>
          <h2 data-m="up" className="h-section mt-6">Find the <span className="text-primary-500">fire.</span></h2>
        </div>
        <p data-m="up" data-m-delay="200" className="md:col-span-4 text-base leading-[1.7] text-foreground-700">Two grills, same rules. Walk in, order at the counter, <span className="hand text-foreground-950 text-lg">eat it hot.</span></p>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-10">
        {locations.map((loc, i) => (
          <Reveal key={loc.id}>
            <article id={`loc-${loc.id}`} className="group scroll-mt-[90px] poster-card hard-drop">
              <div data-m="enter" data-m-delay={String(i * 160)} className="m-zoom aspect-[3/2] w-full overflow-hidden border-b-[2.5px] border-foreground-950">
                <img src={loc.image} alt={`FIRE CLUB ${loc.name}`} title={`FIRE CLUB ${loc.name} burger bar`} loading="lazy" decoding="async" className="h-full w-full object-cover object-center" />
              </div>
              <div data-m="up" data-m-delay={String(i * 160 + 250)} className="p-5 md:p-7">
                <div className="flex items-center justify-between gap-4 pb-4">
                  <h3 className="h-card">{loc.name}</h3>
                  <span className="sticker !text-[14px] bg-accent-500 text-background-50 tilt-r">{loc.status}</span>
                </div>
                <dl className="text-[15px]">
                  <div className="grid grid-cols-[110px_1fr] items-center min-h-14 py-3 border-t-2 border-dashed border-foreground-300">
                    <dt className="hand text-sm text-foreground-600">address</dt>
                    <dd className="font-medium">{loc.address}</dd>
                  </div>
                  {loc.hours.map((h) => (
                    <div key={h.day} className="grid grid-cols-[110px_1fr] items-center h-14 border-t-2 border-dashed border-foreground-300">
                      <dt className="hand text-sm text-foreground-600">{h.day}</dt>
                      <dd className="tabular-nums font-medium">{h.time}</dd>
                    </div>
                  ))}
                </dl>
                <div className="mt-6 flex flex-wrap gap-3">
                  <Link to="/contact#book" className="btn-poster btn-berry btn-sm">
                    Book a Table
                    <span className="w-4 h-4 flex items-center justify-center"><i className="ri-calendar-event-line" /></span>
                  </Link>
                  <Link to={`/locations#${loc.id}`} className="btn-poster btn-paper btn-sm">
                    Location Details
                    <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-up-line" /></span>
                  </Link>
                </div>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </section>
  );
}